<template>
  <div>
    <div v-if="!newCard">
      <form>
        <select v-if="items.length" v-model="model">
          <option v-for="item in items" :key=item.id :value="item.id">{{item.display}}</option>
        </select>
        <button class="btn" @click="newCard=!newCard">Add new card</button>
      </form>
    </div>
    <card-form v-if="newCard"
      v-on:add="newCard=!newCard;getClientCard()"
      v-on:cancel="newCard=!newCard"
    ></card-form>
  </div>
      
    
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CardForm from "./CardForm.vue";

export default {
  components: {
    CardForm
  },
  props:{
    value:{
      type:Number,
      default: () => null
    }
  },
  data() {
    return {
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      message: null,
      search: null,
      isLoading: false,
      newCard: false
    };
  },
  computed:{
    ...mapGetters("card",{items:"list"}),
    model:{
      get(){
        return this.value
      },
      set(v){
        this.$emit("input", v);
      }
    }
  },
  mounted: function() {
    this.getClientCard();
  },
  methods: {
    ...mapActions("card", {getClientCard:"list"}),
  }
};
</script>

<style scoped lang="less">
#app form{
  flex-direction: row;
  button{
    margin-left: 50px;
  }
}
</style>
